import React, { Component } from 'react';
import { translate } from '../../services';
import { BusyContainer, ClipboardProductImport } from '..';
import { PropTypes } from 'prop-types';
import { Box, IconButton as MuiIconButton } from '@mui/material';
import { CloseIconNew, closePopup } from '../../../style/images';

export class ClipboardImport extends Component {
  constructor() {
    super();
    this.state = {inputString : ''};
  }

  handleImportTextFieldChange = e => {
    this.setState({inputString : e.target.value});
  }

  updateImport = (seperator,flag=false) => {    
    var formattedString=''
    if(this.state.inputString.toUpperCase().indexOf(' ')>-1){
       formattedString = this.state.inputString.toUpperCase().replaceAll(' ', seperator);
    }
    else{
      formattedString = this.state.inputString.toUpperCase().replaceAll('\n', seperator);
    }
    const productParts = this.getSplitedValues( formattedString, ';' );
    let productList = [];

    for ( let productPart of productParts ) {
      const productCodes = this.getSplitedValues( productPart, ',' );
      let product = { product: productCodes[0].trim(), importAccessories: [] };
      for ( let i = 1; i < productCodes.length; i++ ) {
        product.importAccessories.push( {'accessoryCode':productCodes[i].trim()} );
      }
      productList.push( product );
    }
    this.props.updateProducts( productList,flag );
  }

  getSplitedValues( importString, separation = '; ' ) {
    let values = importString.includes( separation ) ? importString.split( separation ) : [importString];
    for ( let i = 0; i < values.length; i++ ) {
      const value = values[i].trim();
      values[i] = value;

      if ( !value ) {
        values = values.remove( value, value => value );
        i--;
        continue;
      }
    }
    return values;
  }

  generateImportString( products ) {
    let importString = '';

    for( let i = 0; i < products.length; i++ ) {
      const product = products[i];

      if( i > 0 ) {
        importString += ';';
      }

      importString += product.product;

      for ( let accessory of product.accessories ) {
        importString += `, ${accessory}`;
      }
    }
    importString += this.state.inputString.endsWith( ',' ) ? ',' : '';
    return importString;
  }

  updateProduct = ( position, productCode, accessories ) => {
    const { products } = this.props;
    const code = productCode.trim();
    const product = !code ? undefined : { product: productCode.trim(), accessories: this.getSplitedValues( accessories, ',' ) };
    let newProducts;
    

    if ( !products[position] && code ) {
      newProducts = [...products, product]; //add
    } else if ( code ) {
      newProducts = [...products.slice( 0, position ), product, ...products.slice( position + 1 )]; //update
    } else {
      newProducts = [...products.slice( 0, position ), ...products.slice( position + 1 )]; //remove
    }
    this.props.updateProducts( newProducts );
  }

  validate = () => this.updateImport(';');

  import = () => this.updateImport(',',true);

  render() {
    const { isBusy, products } = this.props;
    // *****
    //  This section is commented to change the implementtion from multi configuration import to single configuration import
    // *****
    // const productLines = products.map( ( product, key ) => <ClipboardProductImport key={ key } position={ key } updateProduct={ this.updateProduct } product={ product }/> );
    // productLines.push( <ClipboardProductImport key={ productLines.length } position={ productLines.length } updateProduct={ this.updateProduct }/> );
    return <div className="clipboard-import">
      {/* <h3>{ translate( 'Clipboard Import' ) }</h3> */}
      <BusyContainer isBusy={ isBusy }>
        {/* <div className="products-import">
          { productLines }
        </div> */}
        {/* <span>{ translate( 'Copy a product list (semicolon separated) in the text area below and press Validate to verify you code list or Import directly' ) }</span> */}
        {!this.props.mobileCartFooter?<>
          <span className='description'>{ translate( 'VALIDATE_PLACEHOLDER' ) }</span>
        <textarea spellcheck="false" className="import-text-area" placeholder={translate("start typing here...")} onChange={ this.handleImportTextFieldChange } value={ this.state.inputString || this.generateImportString( products ) }/>
        <div className="button-panel">
          <div className='tertiary-button' onClick={ this.validate }><span>{ translate( 'VALIDATE' ) }</span></div>
          <div className='primary-button' onClick={ this.import }><span>{ translate( 'VALIDATE_CONFIGURATION' ) }</span></div>
        </div>
        </>:<>
        {/* <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.props.onClose} width="24px" height="24px" sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5", height:"20px", width:"20px", borderRadius:"56px"}}>
                            <Box component="img" src={CloseIconNew} sx={{height:"16px", width:"16px"}}></Box>
            </MuiIconButton> */}
            <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.props.onClose} sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5",width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}, borderRadius:"56px" , backgroundColor: 'white'}}>
              <Box component="img" src={closePopup} style={{width: 'inherit', height: 'inherit'}} sx={{height:"24px", width:"24px"}}></Box>
            </MuiIconButton>
          <h6>{translate("Would you like to order items from the cart?")}</h6>
          <span className='description'>{ translate( 'VALIDATE_PLACEHOLDER' ) }</span>
          <textarea spellcheck="false" className="import-text-area" placeholder={translate("start typing here...")} onChange={ this.handleImportTextFieldChange } value={ this.state.inputString || this.generateImportString( products ) }/>
          <div className='mobile-import-footer'>
            <Box sx={{display:"flex", alignItems:"flex-start", gap:"8px"}}>
            <div className="tertiary-button check-over-btn" onClick={this.props.onClose}>
                                          <span>{translate("Cancel")}</span>
                                      </div>
            <div className='primary-button' disabled={ this.state.file===""?true:isBusy?true:false }  onClick={ this.import }><span>{ translate( 'Import' ) }</span></div>
            </Box>
          </div>
        </>}

      </BusyContainer>
    </div>;
  }
}

ClipboardImport.propTypes = {
  import: PropTypes.func.isRequired,
  isBusy: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf( PropTypes.object ).isRequired,
  updateProducts: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired
};